// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function ClientsCarousel(Props) {
  const match = React.useState(function () {
    return 0;
  });
  const setIdx = match[1];
  const idx = match[0];
  const match$1 = React.useState(function () {
    
  });
  const setInt = match$1[1];
  const interval = match$1[0];
  const textRef = React.useRef(null);
  const clean = function (param) {
    if (interval !== undefined) {
      clearInterval(Caml_option.valFromOption(interval));
      return;
    }
    
  };
  const match$2 = Buhta_landing__Content.Context.useContent(undefined);
  const homePage = match$2[0].homePage;
  const clients_0 = {
    quote: homePage.carousel_client_quote_1,
    name: homePage.carousel_client_name_1,
    logo: JsxRuntime.jsx("img", {
      className: "w-34",
      src: StaticAsset.src("/static/icons/davai-shodim-black.svg")
    })
  };
  const clients_1 = {
    hd: {
      quote: homePage.carousel_client_quote_2,
      name: homePage.carousel_client_name_2,
      logo: JsxRuntime.jsx("img", {
        className: "w-34",
        alt: "yapartner",
        src: StaticAsset.src("/static/images/yapartner.png")
      })
    },
    tl: {
      hd: {
        quote: homePage.carousel_client_quote_3,
        name: homePage.carousel_client_name_3,
        logo: JsxRuntime.jsx("img", {
          className: "h-8 w-34",
          src: StaticAsset.src("/static/icons/nommi.svg")
        })
      },
      tl: /* [] */ 0
    }
  };
  const clients = {
    hd: clients_0,
    tl: clients_1
  };
  React.useEffect((function () {
    const textElement = textRef.current;
    Belt__Belt_Option.map((textElement == null) ? undefined : Caml_option.some(textElement), (function (el) {
      el.classList.add("animate-fadeInSlow");
      const remove = setTimeout((function (param) {
        el.classList.remove("animate-fadeInSlow");
      }), 400);
      return function (param) {
        clearTimeout(remove);
      };
    }));
    const intrvl = setInterval((function (param) {
      const nextIdx = idx + 1 | 0;
      if (nextIdx < Stdlib__List.length(clients)) {
        return Curry._1(setIdx, (function (param) {
          return nextIdx;
        }));
      } else {
        return Curry._1(setIdx, (function (param) {
          return 0;
        }));
      }
    }), 3000);
    Curry._1(setInt, (function (param) {
      return Caml_option.some(intrvl);
    }));
    return (function (param) {
      clearInterval(intrvl);
    });
  }), [idx]);
  const client = Stdlib__List.nth(clients, idx);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        ref: textRef,
        children: [
          JsxRuntime.jsx("p", {
            children: client.quote,
            className: "paragraph-large text-center text-black-landing min-h-28 lg:min-h-0"
          }),
          JsxRuntime.jsx("p", {
            children: client.name,
            className: "paragraph-small text-center text-black-landing mt-2 lg:mt-4"
          })
        ]
      }),
      JsxRuntime.jsx("div", {
        children: client.logo,
        className: "flex m-auto mt-6 h-8"
      }),
      JsxRuntime.jsx("div", {
        children: Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, param) {
          const Key = "carousel_step_" + String(i);
          return JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("img", {
              className: i === idx ? "opacity-100" : "opacity-24",
              src: StaticAsset.src("/static/icons/step.svg")
            }),
            className: "ml-2 first:ml-0 cursor-pointer py-4",
            onClick: (function (param) {
              clean(undefined);
              Curry._1(setIdx, (function (param) {
                return i;
              }));
            })
          }, Key);
        }), clients)),
        className: "flex m-auto mt-6 lg:mt-4"
      })
    ],
    className: "flex m-auto lg:mt-30 lg:w-304 bg-warning justify-between flex-col lg:rounded-sm pt-10 lg:pt-16 pb-6 lg:pb-12 px-6 sm:px-48 lg:px-0"
  });
}

const make = ClientsCarousel;

export {
  make,
}
/* Buhta_landing__Content Not a pure module */
